import { AppError } from '../AppError'

export interface ICommunication {
  isLoading: boolean
  isSuccess: boolean
  error: AppError | undefined
}

export const initialCommunication: ICommunication = {
  isLoading: false,
  isSuccess: false,
  error: undefined,
}
